import { IconProps } from "./types";
import React from "react";

export const ClockIcon = ({
  className,
  fill = "currentColor",
  width = 12,
  height = 12,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 12 12"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M6.00006 1.49902C3.51569 1.49902 1.50006 3.51465 1.50006 5.99902C1.50006 8.4834 3.51569 10.499 6.00006 10.499C8.48443 10.499 10.5001 8.4834 10.5001 5.99902C10.5001 3.51465 8.48443 1.49902 6.00006 1.49902Z"
      stroke={fill}
      strokeMiterlimit="10"
    />
    <path
      d="M6 3V6.375H8.25"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
